import React, { useState, useEffect } from 'react'
import {
  ButtonGroup,
  CheckPicker,
  Col,
  ControlLabel,
  Icon,
  IconButton,
  Input,
  InputGroup,
  Message,
  Panel,
  Row,
  SelectPicker,
  Uploader,
} from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { isImageOrPdf, isValidators, requiredFiled } from '../../utils/ValidatorUtils'
import ErrorMessage from '../../components/message/errorMessage/ErrorMessage'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import notification from '../../utils/notification'
import { cloneDeep, isEmpty } from 'lodash-es'
import { getValueFromOptions } from '../../utils/dataUtil'

export default function ResearchView(props) {
  const {
    index,
    itemValue,
    onSubmit = () => {},
    onPreview = () => {},
    onDownload = () => {},
    onDelete = () => {},
    onPreviewFilePath = () => {},
    onDownloadFilePath = () => {},
    isSuccess,
  } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()

  const [formSchema, setFormSchema] = useState(props.schema)
  const [creatorValue, setCreatorValue] = useState([])
  const [fileTypeError, setFileTypeError] = useState(false)
  const [fileCountError, setFileCountError] = useState(false)
  const [filesImage, setFilesImage] = useState(null)
  const [files, setFiles] = useState(null)
  const [fileList, setFileList] = useState([])
  const [fileList2, setFileList2] = useState([])
  const [nameOfResearcherValue, setNameOfResearcherValue] = useState([])
  const [formValues, setFormValues] = useState()

  const rowStyle = { marginTop: 8 }

  useEffect(() => {
    // const countValues = formSchema?.values?.length || 0

    setFilesImage(itemValue.attachFiles)

    let newArr = []
    if (itemValue?.nameOfResearcher?.length > 0) {
      itemValue.nameOfResearcher.map((item, index) => {
        newArr.push(item)
      })
    } else {
      newArr.push('')
    }

    setNameOfResearcherValue(newArr)
  }, [itemValue])

  useEffect(() => {
    console.log('isSuccess => ', isSuccess)
    if (isSuccess) {
      setFileList([])
      setFileList2([])
    }
  }, [isSuccess])

  const setValueName = (index, indexName, value) => {
    const x = cloneDeep(nameOfResearcherValue)

    x[indexName] = value

    setNameOfResearcherValue(x)
  }

  const addItemName = () => {
    const x = cloneDeep(nameOfResearcherValue)

    let newArr = x || []
    newArr.push('')

    setNameOfResearcherValue(newArr)
  }

  const deleteItemName = (index, indexName) => {
    const x = cloneDeep(nameOfResearcherValue)
    x.splice(indexName, 1)

    setNameOfResearcherValue(x)
  }

  const tableAttachFiles = (files) => {
    return (
      <table width={'100%'} border={1}>
        <thead>
          <tr>
            <th width="10%" style={{ textAlign: 'center' }}>
              <p style={{ padding: 3 }}>ลำดับ</p>
            </th>
            <th width="75%">
              <p style={{ padding: 3 }}>{`ไฟล์ (รวม ${filesImage?.length} ไฟล์)`}</p>
            </th>
            <th width="15%">
              <p style={{ padding: 3 }}>#</p>
            </th>
          </tr>
        </thead>
        <tbody>
          {filesImage?.map((item, index) => {
            return (
              <tr>
                <td align="center">{index + 1}</td>
                <td>
                  <p style={{ padding: 3 }}>{item.label}</p>
                </td>
                <td align="center">
                  <div style={{ padding: 3 }}>
                    <ButtonGroup>
                      <IconButton
                        appearance="ghost"
                        size="sm"
                        icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                        onClick={() => onPreview(item)}
                        // disabled={!item?.path}
                      />
                      <IconButton
                        appearance="ghost"
                        size="sm"
                        icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                        onClick={() => onDownload(item)}
                        // disabled={!item?.path}
                      />
                    </ButtonGroup>
                  </div>
                </td>
              </tr>
            )
          })}
        </tbody>
      </table>
    )
  }

  const tableAttachSingleFiles = (files) => {
    return (
      <table width={'100%'} border={1}>
        <thead>
          <tr>
            <th width="10%" style={{ textAlign: 'center' }}>
              <p style={{ padding: 3 }}>ลำดับ</p>
            </th>
            <th width="75%">
              <p style={{ padding: 3 }}>{`ไฟล์`}</p>
            </th>
            <th width="15%">
              <p style={{ padding: 3 }}>#</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td align="center">{index + 1}</td>
            <td>
              <p style={{ padding: 3 }}>{files.slice(13)}</p>
            </td>
            <td align="center">
              <div style={{ padding: 3 }}>
                <ButtonGroup>
                  <IconButton
                    appearance="ghost"
                    size="sm"
                    icon={<Icon icon="eye" className="bt-gost-icon-radius" />}
                    onClick={() => onPreviewFilePath(files)}
                    // disabled={!item?.path}
                  />
                  <IconButton
                    appearance="ghost"
                    size="sm"
                    icon={<Icon icon="download" className="bt-gost-icon-none-radius" />}
                    onClick={() => onDownloadFilePath(files)}
                    // disabled={!item?.path}
                  />
                  {/* <IconButton
                    appearance="ghost"
                    size="sm"
                    className="rs-btn-ghost-cancel"
                    icon={<Icon icon="trash" className="bt-gost-icon-radius-cancel" />}
                    // onClick={() => onDelete(item)}
                    // disabled={!item?.path}
                  /> */}
                </ButtonGroup>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    )
  }

  const convertArrayToStringInline = (strArray) => {
    let str = ''
    if (strArray?.length > 0) {
      strArray.map((item, index) => {
        console.log('item => ', item)
        str += `${index + 1}. ${item} <br />`
      })

      return str
    }

    return ''
  }

  return (
    <>
      <Panel
        // shaded
        collapsible
        defaultExpanded
        header={`${formSchema.header}ที่ ${index + 1} `}
        bordered
        key={index}
        style={{ marginBottom: 10 }}
      >
        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.nameTh.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {itemValue.nameTh || ''}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.nameEng.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {itemValue.nameEng || ''}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.issue.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {itemValue.issue || null}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={{ marginTop: 15 }}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.target.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <div
              dangerouslySetInnerHTML={{ __html: convertArrayToStringInline(itemValue?.target) }}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        {/*<Row style={rowStyle}>*/}
        {/*  <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>*/}
        {/*    <ControlLabel>*/}
        {/*      {requiredFiled(*/}
        {/*        formSchema.input.importance.validators,*/}
        {/*        formSchema.input.importance.label*/}
        {/*      )}*/}
        {/*    </ControlLabel>*/}
        {/*  </Col>*/}
        {/*  <Col lg={16} md={16} sm={16} xs={16}>*/}
        {/*    <ErrorMessage*/}
        {/*      error={errors[`${formSchema.input.importance.name}`]}*/}
        {/*    />*/}
        {/*    <Input*/}
        {/*      key={`${formSchema.input.importance.name}`}*/}
        {/*      name={`${formSchema.input.importance.name}`}*/}
        {/*      defaultValue={formSchema.input.importance.value}*/}
        {/*      disabled={formSchema.input.importance.disabled}*/}
        {/*      inputRef={register(isValidators(formSchema.input.importance.validators))}*/}
        {/*    />*/}
        {/*  </Col>*/}
        {/*  <Col lg={2} md={2} sm={2} xs={2}></Col>*/}
        {/*</Row>*/}

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.objective.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {itemValue.objective || ''}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.benefit.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {itemValue.benefit || ''}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={{ marginTop: 15 }}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.nameOfResearcher.label} : </b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <div
              dangerouslySetInnerHTML={{
                __html: convertArrayToStringInline(nameOfResearcherValue),
              }}
            />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        {/* <Row style={rowStyle}>
                    <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
                      <ControlLabel>
                        {requiredFiled(
                          formSchema.input.nameOfResearcher.validators,
                          formSchema.input.nameOfResearcher.label
                        )}
                      </ControlLabel>
                    </Col>
                    <Col lg={16} md={16} sm={16} xs={16}>
                      <ErrorMessage
                        error={errors[`${formSchema.input.nameOfResearcher.name}`]}
                      />
                      <Input
                        key={`${formSchema.input.nameOfResearcher.name}`}
                        name={`${formSchema.input.nameOfResearcher.name}`}
                        defaultValue={formSchema.input.nameOfResearcher.value}
                        disabled={formSchema.input.nameOfResearcher.disabled}
                        inputRef={register(
                          isValidators(formSchema.input.nameOfResearcher.validators)
                        )}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                  </Row> */}

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.yearOfDevelopment.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {itemValue.yearOfDevelopment.toString() || ''}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.attachFiles.header} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <br />

            {filesImage?.length > 0 && <div style={{ marginTop: 10 }}>{tableAttachFiles()}</div>}

            <br />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        {/* <Row style={rowStyle}>
                    <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
                      <ControlLabel>
                        {requiredFiled(
                          formSchema.input.linked.validators,
                          formSchema.input.linked.label
                        )}
                      </ControlLabel>
                    </Col>
                    <Col lg={16} md={16} sm={16} xs={16}>
                      <ErrorMessage error={errors[`${formSchema.input.linked.name}`]} />
                      <Input
                        key={`${formSchema.input.linked.name}`}
                        name={`${formSchema.input.linked.name}`}
                        defaultValue={formSchema.input.linked.value}
                        disabled={formSchema.input.linked.disabled}
                        inputRef={register(isValidators(formSchema.input.linked.validators))}
                      />
                    </Col>
                    <Col lg={2} md={2} sm={2} xs={2}></Col>
                  </Row> */}

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.completeEditionAttachFiles.header} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            <br />

            <br />
            {itemValue.completeEditionAttachFiles &&
              tableAttachSingleFiles(itemValue.completeEditionAttachFiles)}
            <br />
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <hr />
            <p style={{ color: '#2da888', marginLeft: 15 }}>{formSchema.contactChannels.title}</p>
          </Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.contactChannels.fullName.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {itemValue.fullName || ''}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.contactChannels.email.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {itemValue.email || ''}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.contactChannels.telephone.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {itemValue.telephone || ''}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.contactChannels.agency.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {itemValue.agency || ''}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={24} md={24} sm={24} xs={24}>
            <hr />
            <p style={{ color: '#2da888', marginLeft: 15 }}>{formSchema.evaluationTitile}</p>
          </Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.criteria1.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {getValueFromOptions(
              formSchema.input.criteria1.options,
              itemValue.criteria1.toString()
            ) || '-ไม่ระบุ-'}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.criteria2.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {getValueFromOptions(
              formSchema.input.criteria2.options,
              itemValue.criteria2.toString()
            ) || '-ไม่ระบุ-'}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row style={rowStyle}>
          <Col lg={6} md={6} sm={6} xs={6} style={{ textAlign: 'right' }}>
            <b>{formSchema.input.criteria3.label} :</b>
          </Col>
          <Col lg={16} md={16} sm={16} xs={16}>
            {getValueFromOptions(
              formSchema.input.criteria3.options,
              itemValue.criteria3.toString()
            ) || '-ไม่ระบุ-'}
          </Col>
          <Col lg={2} md={2} sm={2} xs={2}></Col>
        </Row>

        <Row>
          <Col lg={24} md={24} sm={24} xs={24} style={{ marginBottom: 10, marginTop: 10 }}>
            {itemValue.typeSendFlag && itemValue.strSendFlag && (
              <div>
                <Message
                  showIcon
                  type={itemValue.typeSendFlag}
                  // title={itemValue.strSendFlag}
                  description={itemValue.strSendFlag}
                />
              </div>
            )}
          </Col>
        </Row>
      </Panel>
    </>
  )
}
